module.exports = __webpack_public_path__ + "static/media/art2.8379488f.jpg";